module.exports = "/images/lock.svg?9a73854144d665f5114284eee85672a1";